import {Col} from "react-bootstrap";
import {Link} from "react-router-dom";

export const ShortcutCard = ({
                                 title,
                                 description,
                                 imgUrl,
                                 url,
                                 id = "",
                                 onClick,
                                 backgroundColor,
                                 textColor,
                                 isExternal = false,
                             }) => {
    const fullUrl = id ? `${url}/${id}` : url;

    const cardContent = (
        <div className="proj-imgbx" style={{backgroundColor: backgroundColor || "rgb(0,0,0)",}}>
            {imgUrl ? (
                <img src={imgUrl} alt={title} className="proj-img"
                     style={{width: "100%", height: "100%", objectFit: "cover"}}/>
            ) : (
                // Fallback: muestra la primera letra del título en un recuadro
                <div
                    className="fallback-image"
                    style={{
                        fontSize: "4rem",
                        fontWeight: "bold",
                        color: textColor || "#fff",
                    }}
                >
                    {title.charAt(0)}
                </div>
            )}
            <div className="proj-txtx">
                <span>{description}</span>
            </div>
        </div>
    );

    return (
        <section
            className="shortcuts-card"
            onClick={onClick}
            style={onClick ? {cursor: "pointer"} : {}}
        >
            <Col>
                {isExternal ? (
                    <a href={fullUrl} target="_blank" rel="noopener noreferrer">
                        {cardContent}
                        <h4 style={{color: textColor || "rgb(29,29,29)"}}>{title}</h4>
                    </a>
                ) : (
                    <Link to={fullUrl}>
                        {cardContent}
                        <h4 style={{color: textColor || "rgb(29,29,29)"}}>{title}</h4>
                    </Link>
                )}
            </Col>
        </section>
    );
};
